import React, {useState, useEffect, useRef, forwardRef} from 'react'

import Button from './Button'

const PasswordField = forwardRef((props, passwordRef) => {
  const [isVisible, setIsVisible] = useState(false)

  const handleTogglePasswordVisibility = () => {
    const type = $("#password").attr("type") === "password" ? "text" : "password"
    $("#password").attr("type", type)
    setIsVisible(!isVisible)
  }

  const handleOnChange = () => {
    if ($(passwordRef.current).val() !== "") {
      props.onKeyUp(true)
    } else {
      props.onKeyUp(false)
    }
  }

  useEffect(() => {
    if (props.currentStep == 2) {
      passwordRef.current.focus()
    }
  }, [props.currentStep])

  const { ref, ...rest } = props.register("user[password]")

  return (
    <div aria-hidden={props.hidden} className='input-group' >
      <label htmlFor='password'>password</label>
      <div style={{position: 'relative'}}>
        <i
          className={
            isVisible
              ? "fa-light fa-eye-slash"
              : "fa-light fa-eye"
          }
          onClick={handleTogglePasswordVisibility}
        ></i>
        <i className='fa-light fa-lock input-icons'></i>
        <input
          {...rest}
          ref={e => {
            ref(e)
            passwordRef.current = e
          }}
          className='rounded-edges'
          type='password'
          id='password'
          name='user[password]'
          onKeyUp={handleOnChange}
          autoComplete='off'
          autoFocus={true}
          required={true}
        />
      </div>
    </div>
  )
})

export default PasswordField
